/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const informationSecurityCybersecurityEnumsPotentiallyCompromisedDataOptionEnum = {
    PersonalData: 'PersonalData',
    FinancialData: 'FinancialData',
    Credentials: 'Credentials',
    CustomerData: 'CustomerData',
    InternalConfidentialDocuments: 'InternalConfidentialDocuments',
    SourceCode: 'SourceCode',
    Other: 'Other',
} as const;

export type InformationSecurityCybersecurityEnumsPotentiallyCompromisedDataOptionEnumKey =
    (typeof informationSecurityCybersecurityEnumsPotentiallyCompromisedDataOptionEnum)[keyof typeof informationSecurityCybersecurityEnumsPotentiallyCompromisedDataOptionEnum];

export type InformationSecurityCybersecurityEnumsPotentiallyCompromisedDataOption =
    InformationSecurityCybersecurityEnumsPotentiallyCompromisedDataOptionEnumKey;
